// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dlRa","colBig":"styles_colBig__1_0BN","colSmall":"styles_colSmall__2OF67","shopifyNameWrapper":"styles_shopifyNameWrapper__3Doz8"};